var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: { "has-line": "", title: "Información de Archivos de Pagos" }
      }),
      _c("payment-file-info-row", {
        attrs: {
          "empty-text": "No hay cuentas a crear en el jornal del pago",
          icon: "fas fa-plus",
          items: _vm.accountsToCreate,
          "on-download-file": _vm.onDownloadFile,
          "payment-journal-status-id": _vm.paymentJournalStatusId,
          title: "Cuentas a Crear"
        },
        on: {
          "on-delete-file-answer": _vm.onDeleteFileAnswerHandler,
          "on-download-account-file": _vm.onDownloadAccountFile,
          "on-generate-new-file": _vm.onGenerateNewFileHandler,
          "on-save-answer-files": _vm.onSaveAnswerFiles
        }
      }),
      _c("payment-file-info-row", {
        staticClass: "mt-4",
        attrs: {
          "empty-text": "No hay cuentas a actualizar en el jornal del pago",
          icon: "fas fa-exchange-alt",
          items: _vm.accountsToUpdate,
          "on-download-file": _vm.onDownloadFile,
          "payment-journal-status-id": _vm.paymentJournalStatusId,
          title: "Cuentas a Actualizar"
        },
        on: {
          "on-delete-file-answer": _vm.onDeleteFileAnswerHandler,
          "on-download-account-file": _vm.onDownloadAccountFile,
          "on-generate-new-file": _vm.onGenerateNewFileHandler,
          "on-save-answer-files": _vm.onSaveAnswerFiles
        }
      }),
      _c("payment-file-info-row", {
        staticClass: "mt-4",
        attrs: {
          "empty-text": "No hay cuentas a pagar en el jornal del pago",
          icon: "fas fa-dollar-sign",
          items: _vm.accountsToPay,
          "on-download-file": _vm.onDownloadFile,
          "payment-journal-status-id": _vm.paymentJournalStatusId,
          title: "Cuentas a Pagar"
        },
        on: {
          "on-delete-file-answer": _vm.onDeleteFileAnswerHandler,
          "on-download-account-file": _vm.onDownloadAccountFile,
          "on-generate-new-file": _vm.onGenerateNewFileHandler,
          "on-save-answer-files": _vm.onSaveAnswerFiles
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }